import React from 'react';
import { IconProps } from '.';

const SvgDetailThreeDots = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M10.25 11.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM14.75 10.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6.75 11.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M10.25 19.5a9.213 9.213 0 0 0 5.989-2.2l5.73 5.73 1.061-1.06-5.73-5.731a9.213 9.213 0 0 0 2.2-5.989 9.25 9.25 0 1 0-9.25 9.25Zm0-1.5a7.75 7.75 0 1 0 0-15.5 7.75 7.75 0 0 0 0 15.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgDetailThreeDots;
